import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/eye_filled"
  }, React.createElement("g", {
    id: "Union"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6602 2.18408L14.2461 0.77002L11.8053 3.21082C10.7195 2.49976 9.44303 2 8 2C3 2 0 8 0 8C0 8 1.10049 10.201 3.07929 11.9368L0.770081 14.246L2.18414 15.6601L15.6602 2.18408ZM5.44426 9.57185L9.57185 5.44426C9.11475 5.16253 8.57636 5 8 5C6.34315 5 5 6.34315 5 8C5 8.57636 5.16253 9.11475 5.44426 9.57185Z",
    fill: "currentColor"
  }), React.createElement("path", {
    d: "M6.44555 13.8037L14.5082 5.74104C15.4786 6.95718 16 8 16 8C16 8 13 14 8 14C7.45792 14 6.93934 13.9295 6.44555 13.8037Z",
    fill: "currentColor"
  }))));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { EyeFilled16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var EyeFilled16 = createIcon(IconComponent);